import React, { ReactNode } from 'react';
import { ErrorType } from '../../types/analytics';
import { COMPONENT_LOADER_OVERLAY } from '../../utils/components-elements';
import { LoadingOverlay } from '../../web-shared/design-system/loading/loading-overlay';
import { Heading } from '../../web-shared/general/heading';
import { PhiloLogo } from '../../web-shared/icons/icon/philo-logo';
import Message, { MessageType } from '../message/message';
import styles from './loader-overlay.module.sass';

export default function LoaderOverlay({
  message = '',
  children,
}: {
  message?: string;
  children?: ReactNode;
}) {
  return (
    <LoadingOverlay
      logo={
        <Heading className={styles.loaderOverlayTitle} level={1}>
          <PhiloLogo />
        </Heading>
      }
      className={styles.loaderOverlay}
    >
      {children}
      {message && (
        <Message
          component={COMPONENT_LOADER_OVERLAY}
          errorType={ErrorType.FULLSCREEN}
          message={message}
          parentClass={styles.loaderOverlayMessage}
          type={MessageType.ERROR}
        />
      )}
    </LoadingOverlay>
  );
}
